import React from 'react';
import { PrimeReactProvider } from 'primereact/api';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { routes } from './helpers/routes';

function renderRoutes(routes) {
  return routes.map((route, i) => {
    if (route.children) {
      return (
        <Route key={i} path={route.path} element={route.element}>
          {renderRoutes(route.children)}
        </Route>
      );
    }
    return <Route key={i} {...route} />;
  });
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {renderRoutes(routes)}
      </Routes>
    </BrowserRouter>
  );
}

export default App;